import { QuestInterface, NodeInterface } from "@swivl-mono/types";
import { warn } from '@swivl-mono/helpers'
import NodeModel from "../../Nodes/NodeModel";


export function PlumbDataFromQuest(quest:QuestInterface) {
        
        let data:any = {nodes:[], edges:[]};
        if (!quest) { return; }
        let nodes = quest.data as { [nodeId: string]: NodeInterface}; 

        for (var key in nodes) {
            let model = NodeModel.forType(nodes[key].type)
            if (model && model.PlumbData) {
              let nodeData = model.PlumbData(nodes[key])
              if (nodeData) {
                data.nodes.push(nodeData.node)
                
                


                data.edges = data.edges.concat(nodeData.edges)
              } else {
                warn("No PlumbData for node: " + nodes[key]);
                
              }
            }
          }
          // for (let index = 0; index < data.edges.length; index++) {
          //   const element = data.edges[index];
             
            
          // }

          return data;
}